import React, { Component } from 'react';
import CarAvatar from './../components/CarAvatar';
import Preloader from './../components/global/Preloader';
import Button from './global/Button';
import { sortCarsList } from '../libs/sortCars';
import CarFilters from './CarFilters';
import { ReactComponent as ImageNoResults } from '../assets/icons-fleet/icon-shorttime-accident.svg';

import '../styles/components/CarsList.css';

const rp = require('request-promise');

export default class CarsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAll: false,
            loading: true,
            filters: {},
            options: [],
            showMore: false,
            sort: { value: 'sort-new', label: 'Od najnowszych' }
        };
    }

    toogleShowMore = showMore => {
        if (
            this.state.filters.categories &&
            this.state.filters.categories.value !== 3
        ) {
            if (typeof showMore === 'boolean') {
                this.setState({ showMore });
            } else {
                if (
                    !!this.state.filters.categories &&
                    !!this.state.filters.typpojazdu
                ) {
                    this.setState({ showMore: !this.state.showMore });
                }
            }
        }
    };

    saveFilters = filters => {
        this.setState({
            filters
        });
    };

    searchCars = async () => {
        this.setState({
            loading: true
        });

        let requestText = '&';

        try {
            let listOfCars = await rp({
                json: true,
                uri: `https://api.v1rage.com/wp-json/wp/v2/cars?per_page=100${requestText}`
            });
            this.setState({
                loading: false,
                listOfCars
            });
        } catch (err) {
            this.setState({
                loading: false,
                listOfCars: []
            });
        }
    };

    componentDidMount() {
        this.searchCars();
    }

    render() {
        const listOfCars = sortCarsList(
            this.state.listOfCars,
            this.state.filters
        );

        return (
            <React.Fragment>
                <CarFilters setFilters={this.saveFilters} />
                <div className="cars-list">
                    <div className="container container-small">
                        {this.state.loading ? (
                            <div className="row">
                                <div className="col-12 text-center">
                                    <Preloader loading={this.state.loading} />
                                </div>
                            </div>
                        ) : (
                            <div
                                className={`row cars-list--items ${
                                    this.state.showAll ? 'show-all' : ''
                                }`}
                            >
                                {listOfCars.length > 0 ? (
                                    listOfCars.map((singleCar, idx) => {
                                        return (
                                            <div
                                                key={idx}
                                                className="col-12 col-sm-6 col-md-4"
                                            >
                                                <CarAvatar
                                                    key={idx}
                                                    carData={singleCar}
                                                />
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="col-12">
                                        <ImageNoResults className="svg empty" />
                                        <h4>Brak wyników wyszukiwania.</h4>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {!this.state.loading &&
                        listOfCars.length > 12 && (
                            <div className="row cars-list--load-more">
                                <div className="col-12 text-center">
                                    <Button
                                        classes={`btn-general btn-general--secondary text-center no-icon`}
                                        text={
                                            !this.state.showAll
                                                ? `Pokaż wszystkie`
                                                : 'Ukryj wszystkie'
                                        }
                                        onClick={() =>
                                            this.setState({
                                                showAll: !this.state.showAll
                                            })
                                        }
                                    />
                                </div>
                            </div>
                        )}
                </div>
            </React.Fragment>
        );
    }
}
